import { Component, OnInit } from '@angular/core';
import { trigger,transition,style,animate } from '@angular/animations';
import { Title,Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger('slideFromBottom', [
        transition(':enter', [
            style({ transform: 'translateY(100%)', opacity: 0 }),
            animate('1s ease-in-out', style({ transform: 'translateY(0)', opacity: 1 })) // Default speed
        ]),
    ]),
    trigger('slideFromBottomFast', [
        transition(':enter', [
            style({ transform: 'translateY(100%)', opacity: 0 }),
            animate('0.75s ease-in-out', style({ transform: 'translateY(0)', opacity: 1 })) // Fast speed
        ]),
    ]),
    trigger('slideFromBottomSlow', [
        transition(':enter', [
            style({ transform: 'translateY(100%)', opacity: 0 }),
            animate('1.5s ease-in-out', style({ transform: 'translateY(0)', opacity: 1 })) // Slow speed
        ]),
    ]),
]
})
export class HomeComponent implements OnInit {

  constructor(public router: Router, private titleService: Title, private metaService: Meta) { }
  Display_loader : boolean = true;
  ngOnInit(): void {
    setTimeout(() => {
      this.titleService.setTitle('Top-Rated Digital Marketing Agency in Hyderabad for Your Success');
      this.metaService.updateTag({
        name: 'description',
        content: 'Get expert digital marketing services in Hyderabad with customized strategies in SEO, social media, and paid ads. Achieve your goals with proven online solutions.',
      });
      this.setCanonicalTag('https://sharkify.ai/Home');
    }, 100);

    this.Display_loader = false;
  }
  setCanonicalTag(url: string) {
    let link: HTMLLinkElement = document.querySelector("link[rel='canonical']") || document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  }

  displayloader(display : boolean){
    this.Display_loader = display;
  }
  Contactus(){
    this.router.navigate(["/ContactUs"]);
  }

}